import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import SPPOS_poster from '../../../Assets/Images/ProjectsImg/Determinants of Successful Public Parks and Open Spaces (SPPOS)/SPPOS.jpeg';

const SPPOS = () => {

    return (
        <div className="mt-5">
            <h4>Determinants of Successful Public Parks and Open Spaces (SPPOS)</h4>

            <div className="card mt-5">
                <img
                    src={SPPOS_poster}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>

            <div className="mt-5">
                <p>The training program on "Determinants of Successful Public Parks and Open Spaces (SPPOS)" examines the key physical, social, ecological, and managerial factors that contribute to vibrant and inclusive urban open spaces. It emphasizes context-driven design, community engagement, and sustainable maintenance practices for long-term success.</p>
                <p>This 3-day offline program focuses on the critical role of public parks and open spaces (PPOS) in urban life. It addresses the environmental, social, economic, and governance determinants that contribute to the success or failure of these spaces. Through a comprehensive framework, the course empowers participants to plan, design, manage, and sustain vibrant and inclusive public spaces that meet community needs and promote long-term value.</p>
            </div>

            <div>
                <p><strong>Beneficiaries:</strong> Urban managers, ULBs, planners, architects, engineers, contractors, academics, policy makers, environmental experts, researchers, and allied professionals.</p>
                <p><strong>Aim:</strong> To develop professionals capable of applying integrated, determinant-based approaches to creating successful PPOS across all urban scales.</p>

                <p><strong>Objectives:</strong></p>
                <ul>
                    <li>Understand key success determinants (environmental, social, etc.)</li>
                    <li>Plan inclusive, accessible designs</li>
                    <li>Apply sustainable management strategies</li>
                    <li>Foster community engagement</li>
                    <li>Influence policy and governance structures</li>
                </ul>

                <p className='mt-4'><strong>Timeline & Duration:</strong> 3 Days (24 Hours | 2–4 Credits)</p>
                <p className='mt-4'><strong>Mode:</strong> Offline</p>

                {/* <p><strong>Status:</strong> Completed</p> */}
            </div>
        </div>
    );
};

export default SPPOS;

